import { useEffect } from 'react';

function useScrollReveal(selector = '.reveal') {
  useEffect(() => {
    const elements = new Set();
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      document.querySelectorAll(selector).forEach((element) => {
        element.classList.add('is-visible');
      });
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
          elements.delete(entry.target);
        });
      },
      {
        threshold: 0.08,
        rootMargin: '0px 0px -4% 0px',
      }
    );

    const observeElements = () => {
      document.querySelectorAll(selector).forEach((element) => {
        if (elements.has(element) || element.classList.contains('is-visible')) return;

        elements.add(element);
        observer.observe(element);
      });
    };

    observeElements();

    const mutationObserver = new MutationObserver(observeElements);
    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      mutationObserver.disconnect();
      observer.disconnect();
      elements.clear();
    };
  }, [selector]);
}

export default useScrollReveal;
